<div class="h-full">
  <router-outlet></router-outlet>
</div>
